import _round from 'lodash/round';

import { addThousandsSeparatorToString } from './addThousandsSeparatorToString';

/**
 * Given a number, ensure that it has at least two decimals of precision, prepend a dollar sign,
 * and add commas as thousands separators.
 */
export const formatDollarsLong = (
    input: number,
    precision?: number,
    prefix = '$',
): string => {
    let value = input;

    if (precision) {
        value = _round(input, precision);
    }

    const numberAsString = value.toString();
    const numberAsStringParts = numberAsString.split('.');
    const partBeforeDecimal = numberAsStringParts[0] ?? '';
    const partAfterDecimal = numberAsStringParts[1] ?? '';
    const currentPrecision =
        partAfterDecimal !== undefined ? partAfterDecimal.length : 0;
    const zeroPad = '00';
    const zeroesToAdd =
        currentPrecision > 1 ? '' : zeroPad.slice(0, 2 - currentPrecision);
    const newPartBeforeDecimal =
        addThousandsSeparatorToString(partBeforeDecimal);

    return `${prefix}${newPartBeforeDecimal}.${partAfterDecimal}${zeroesToAdd}`;
};
